var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"language-container"},[_c('span',{staticClass:"language-title",on:{"click":_vm.switchLang}},[_vm._v(_vm._s(_vm.lang === 'en' ? '简体中文' : 'English'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }